import { getObject, getText } from "../../ChoiceApi";
import { ProviderDailyCounts } from "../../../ChoiceScreens/Gadget/ProviderDailyCounts";

export const GadgetService = {
    GetClaimsInspectorGadgetData,
    GetLastLoadDate
}

export async function GetClaimsInspectorGadgetData(dayCount: number): Promise<ProviderDailyCounts[] | undefined>
{
    return await getObject<ProviderDailyCounts[]>(`api/datamart/ClaimInspectorGadgetData/${dayCount}`) ?? undefined; 
}

export async function GetLastLoadDate(systemId: number): Promise<string | undefined>
{
    return await getText(`api/datamart/LastLoadDateAsString/${systemId}`) ?? undefined; 
}